:host{
  /* Size */
  --calendar-trigger-width: var(--jb-date-input-calendar-trigger-width, auto);
  --calendar-trigger-height: var(--jb-date-input-calendar-trigger-height, 100%);
  /* Theme/Color */
  --calendar-icon-color: var(--jb-date-input-calendar-icon-color, var(--jb-neutral-6));
  --calendar-icon-color-active: var(--jb-date-input-calendar-icon-color-active, var(--jb-neutral));
  /* Other */
  --margin:var(--jb-date-input-margin,0 0);
  --calendar-trigger-display: var(--jb-date-input-calendar-trigger-display, block);
  --calendar-popover-z-index: var(--jb-date-input-popover-z-index, 1000);
}
